import React from 'react';
// template components
import InformationalModule from '@nmx/template/dist/componentLibrary/modules/InformationalModule';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';

export default () => (
  <InformationalModule
    // configs
    sectionId='investment-advisory-services-product-intro'
    moduleName='intro-module'
    moduleVariation='A'
    // content
    headingText={
      <>
        Investment advice with a <WidowBlock>broader perspective</WidowBlock>
      </>
    }
    introContent={(
      <>
        <Typography
          align='left'
          nextElement='typography'>
          With our Advisory Services, your portfolio will be developed and managed by seasoned financial professionals&#8212;freeing you to focus on other important things. Along with your advisor, the Northwestern Mutual Wealth Management Company investment team provides expertise to help build your ideal portfolio.
        </Typography>
        <Typography
          align='left'
          nextElement='typography'>
          We start with you and your priorities, then following our time&#45;tested philosophy and disciplined process, we select high&#45;quality investment options to help you reach your goals, that could include exposure to&nbsp;
          <Link
            id='esg-portfolios-link'
            variant='primaryDeemphasize'
            linkUrl='/esg-investing/'>
            ESG portfolios
          </Link>
          &nbsp;that reflects your values. With a long&#45;term view of investing, we look to avoid reacting to the day&#39;s headlines and make smarter investment decisions designed to help drive value over time.
        </Typography>
        <Typography
          align='left'
          nextElement='button'>
          We monitor your portfolio to make sure your goals stay on track. And if your priorities change along the way, you&#39;ll generally have the flexibility to change direction.
        </Typography>
        <Link
          id='investment-advisory-services-product-intro-cta-fafa'
          variant='buttonLinkPrimary'
          themeType='lightTheme'
          ariaLabel='Get started with a financial advisor'
          linkUrl='/find-a-financial-advisor/'>
          Get started
        </Link>
      </>
    )}
  />
);
